<template>
  <div>
    <div class="vx-row w-1/2 mb-6 mt-3 ml-1">
      <vs-button color="success" @click="handleDetail()">Create</vs-button>
      <vs-button class="ml-2" color="success" type="border" icon-pack="feather" icon="icon-download" @click="handleImport()">Import</vs-button>
    </div>
    <div class="p-10 my-5 border border-solid rounded-lg">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <span>Supplier</span>
        </div>
        <div class="vx-col sm:w-3/4 w-full">
          <multiselect
            v-model="filter.supplier"
            :options="suppliersData"
            placeholder="Type to search"
            track-by="name"
            label="text"
            :max-height="125"
            :multiple="true"
            :searchable="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <span>Item</span>
        </div>
        <div class="vx-col sm:w-3/4 w-full">
          <multiselect
            v-model="filter.item"
            :options="filterItems"
            placeholder="Type to search"
            track-by="sku_code"
            label="text"
            :max-height="125"
            :internal-search="false"
            @search-change="(val) => debounceSearch(val, 'item')"
            @clear="handleSearchClearItem"
            :multiple="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <span>Shelf-Life GR Days >=</span>
        </div>
        <div class="vx-col sm:w-3/4 w-full">
          <vue-tags-input
            class="w-full"
            v-model="dayInputGr"
            :tags="dayGr"
            placeholder="search"            
            @before-adding-tag="onlyNumber"
            @tags-changed="dayGr = $event"
          />
        </div>
      </div>
      
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <span>Shelf-Life GIR Days >=</span>
        </div>
        <div class="vx-col sm:w-3/4 w-full">
          <vue-tags-input
            class="w-full"
            v-model="dayInputGrr"
            :tags="dayGir"
            placeholder="search"
            @before-adding-tag="onlyNumber"
            @tags-changed="dayGir = $event"
          />
        </div>
      </div>
      <div class="vx-row justify-end">
        <vs-button @click="onClickBtnFilter" size="medium" color="primary" icon-pack="feather"
                   icon="icon-search" title="filter">
          Filter
        </vs-button>
        <vs-button @click="onClickBtnClear" size="medium" class="ml-2" color="primary" icon-pack="feather"
                   icon="icon-search" title="Search">
          Clear
        </vs-button>
      </div>
    </div>
    <div class="vx-row mb-12">
      <div :class="[detail ? 'core vx-col w-full mb-base md:w-1/2' : '', 'core vx-col w-full mb-base md:w-1/1']">
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of {{ this.table.total }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangelength(item)"
                ><span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th sort-key="">Action</vs-th>
            <vs-th sort-key="">Code & Nama Supplier</vs-th>
            <vs-th sort-key="">Code & Nama SKU</vs-th>
            <vs-th sort-key="">Shelf-Life GR Days >=</vs-th>
            <vs-th sort-key="">Shelf-Life GIR Days >=</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="whitespace-no-wrap">
                <div class="flex flex-row space-x-1">
                  <vs-button
                    color="warning"
                    icon-pack="feather"
                    @click="handleDetail(data[indextr].id)"
                    icon="icon-edit"
                  />
                  <vs-button
                    color="danger"
                    icon-pack="feather"
                    @click="handleDelete(data[indextr].id)"
                    icon="icon-trash"
                  />
                </div>
              </vs-td>
              <vs-td :data="data[indextr]">{{ data[indextr].supplier.code }} - {{ data[indextr].supplier.name }}</vs-td>
              <vs-td :data="data[indextr]">{{ data[indextr].item ? `${data[indextr].item.sku_code} ${data[indextr].item.name}` : ''}}</vs-td>
              <vs-td :data="data[indextr]">{{ data[indextr].in_day_gr }}</vs-td>
              <vs-td :data="data[indextr]">{{ data[indextr].in_day_gir }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
        />
      </div>
      <transition name="detail-fade">
        <div class="vertical-divider core vx-col w-full mb-base" v-if="detailS" :class="[detail ? 'md:w-1/2' : 'close md:w-1/1']">
          <vs-col
            style="padding-bottom: 8px"
            vs-offset="8"
            vs-type="flex"
            vs-justify="rigth"
            vs-align="rigth"
            vs-w="4"
          >
            <vs-button
              class="ml-auto min-h-0"
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
            >Close</vs-button>
          </vs-col>
          <vs-col class="flex flex-row align-middle min-h-0">
            <div class="flex items-center w-9">
              <vs-button
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
              ></vs-button>
            </div>
            <div class="flex-1 m-2">
              <div class="font-bold">{{ detailData.id ? "Edit" :  "Create" }}</div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <div class="text-sm">Code & Nama Supplier</div>
                  <multiselect
                    v-model="detailData.supplier"
                    :options="suppliersData"
                    placeholder="Type to search"
                    track-by="name"
                    label="text"
                    :max-height="125"
                    :searchable="true"
                    @select="getItems($event)"
                  >
                    <span slot="noResult">Oops! No data found</span>
                  </multiselect>
                </div>
              </div>
              <div class="vx-row items-end mb-5" :key="indexTr" v-for="(tr, indexTr) in itemLines">
                <div class="vx-col w-2/5">
                  <div class="text-sm">Code & Nama SKU</div>
                  <multiselect
                    v-model="tr.item"
                    :options="items"
                    placeholder="Type to search"
                    track-by="sku_code"
                    label="text"
                    :max-height="125"
                     v-validate="'required'"
                    @clear="handleSearchClearItem"
                  >
                    <span slot="noResult">Oops! No data found</span>
                  </multiselect>
                </div>
                <div class="vx-col w-1/5">
                  <vs-input
                    class="w-full"
                    label="Shelf-Life GR Days >="
                    name="in_day_gr"
                     v-validate="'required'"
                    v-model="tr.in_day_gr"
                    @keypress="isNumber($event)"
                  />
                </div>
                <div class="vx-col w-1/5">
                  <vs-input
                    class="w-full"
                    label="Shelf-Life GIR Days >="
                    name="in_day_gir"
                     v-validate="'required'"
                    v-model="tr.in_day_gir"
                    @keypress="isNumber($event)"
                  />
                </div>
                <div class="vx-col w-1/5">
                  <div class="vx-input-group flex gap-3">
                    <vs-button
                      v-if="itemLines.length > 1 && !isEdit"
                      @click="removeLine(indexTr)"
                      color="danger"
                      icon-pack="feather"
                      icon="icon-trash"
                      title="Remove Row"
                    ></vs-button>
                    <vs-button
                      v-if="!isEdit"
                      icon-pack="feather"
                      icon="icon-plus"
                      type="filled"
                      color="primary"
                      @click="addLine"
                    ></vs-button>
                  </div>
                </div>
              </div>
              <vs-button @click="handleSave()">Save</vs-button>
            </div>
          </vs-col>
        </div>
        <div v-else></div>
      </transition>
    </div>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  components: {
    VueTagsInput,
  },
  name: "",
  data() {
    return {
      controllerItem: new AbortController(),
      suppliersData: [],
      items: [],
      filterItems: [],
      itemLines: [
        {
          item: null,
          in_day_gr: null,
          in_day_gir: null,
        }
      ],      
      detailData: {
        in_day_gr: 1,        
        in_day_gir: 1,
      },
      deleteId: null,
      filter: {},
      dayInputGr: "",
      dayInputGrr: "",
      dayGr: [],
      dayGir: [],
      isEdit: false,
      detailS: false,
      detail: false,
      table: {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      }
    }
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  mounted() {
    this.getSuppliers()
  },
  methods: {
    onlyNumber({ tag, addTag }) {
      console.log("tag", tag)
      if (!/^\d+$/.test(tag.text)) {
        return
      }
      addTag()
    },
    addLine() {
      this.itemLines.push({
        item: null,
        in_day_gr: null,
        in_day_gir: null,
      });
    },
    removeLine(index) {
      this.itemLines.splice(index, 1);
    },
    debounceSearch(searchTerm, type) {
      clearTimeout(this.debounceTimer)

      this.debounceTimer = setTimeout(() => {
        if (type == "division") {
          //this.handleSearchChangeDivision(searchTerm);
        } else {
          this.handleSearchChangeItem(searchTerm)
        }

      }, 2000);
    },
    handleSearchClearItem() {
      this.filterItems = [];
    },
    handleSearchChangeItem(searchTerm) {
      setTimeout(() => {
        console.log("search", searchTerm)
        
        const supplierIds = this.filter.supplier ? this.filter.supplier.map(item => item.id) : []
        // this.cancelTokenItem.cancel()
        this.controllerItem.abort()
        this.$http
          .get("/api/wms/v1/master/shelf-life/item", {
            // cancelToken: this.cancelTokenItem.token,
            signal: this.controllerItem.signal,
            params: {
              search: searchTerm,
              order: "id",
              supplier_id: supplierIds
            },
          })
          .then((resp) => {
            if (resp.code == 200) {
              this.filterItems = resp.data.records.map(r => ({...r, text: `${r.sku_code} ${r.name}`}));
              // console.log(this.items)
              this.$vs.loading.close();
            }
          });
      }, 2000);
    },
    getSuppliers () {
      this.$http
        .get("/api/wms/v1/master/suppliers-v2", {
          params: {}
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.suppliersData = resp.data.records.map(r => ({...r, text: `${r.code} ${r.name}`}));
            this.$vs.loading.close();
          }
        })
    },
    handleSave() {
      this.$validator.validateAll().then((result) => {
        if (!this.detailData.supplier) {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Supplier is required",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          result = false;
          return
        }

        var _this = this
        this.itemLines.forEach(function(element, index){
          if (_this.itemLines[index].item == null) {
            _this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "SKU is required",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            result = false;
            return
          }else if (_this.itemLines[index].in_day_gr == null || _this.itemLines[index].in_day_gr == '') {
            _this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Shelf-Life GR Days >= is required",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            result = false;
            return
          }else if (_this.itemLines[index].in_day_gir == null || _this.itemLines[index].in_day_gir == '') {
            _this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Shelf-Life GIR Days >= is required",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            result = false;
            return
          }else if (_this.itemLines[index].in_day_gr <= 0) {
            _this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Shelf-Life GR Days must be > 0",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            result = false;
            return
          }else if (_this.itemLines[index].in_day_gir <= 0) {
            _this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Shelf-Life GIR Days must be > 0",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            result = false;
            return
          }
        })


        let hasDuplicate = false
        if(result) {
          const ids =this.itemLines.map(item => item.item.id);
          hasDuplicate = ids.some((id, index) => ids.indexOf(id) !== index)
        }

        if (hasDuplicate) {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Duplicate items detected! Please check your items.",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          result = false;
          return
        }

        if (result) {
          this.$vs.loading();
          if (this.detailData.id) {
            this.$http
              .put(`/api/wms/v1/master/shelf-life/${this.detailData.id}`, {
                supplier_id: this.detailData.supplier.id,
                item_lines: this.itemLines.map(line => ({item_code: line.item.sku_code, item_id: line.item.id, in_day_gr: parseInt(line.in_day_gr), in_day_gir: parseInt(line.in_day_gir) })),
                type: "Inbound Supplier SKU",
              })
              .then((resp) => {
                if (resp.code == 200) {
                  this.$vs.notify({
                    title: "Success",
                    text: "Data has been updated",
                    color: "success",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check",
                  });
                  this.handleClose()
                  this.$vs.loading.close();
                } else {
                  if (resp.data.duplicate_item_codes) {
                    console.log('xxxxx')
                    const duplicateItems = resp.data.duplicate_item_codes.join(',')
                    this.$vs.notify({
                      color: "danger",
                      title: "Error",
                      text: `Duplicate items detected! ${duplicateItems}`,
                      position: "top-right",
                      iconPack: "feather",
                      icon: "icon-x-circle",
                    });
                  }
                  this.$vs.loading.close();
                }
              });
          } else {
            this.$http
              .post("/api/wms/v1/master/shelf-life", {
                supplier_id: this.detailData.supplier.id,
                item_lines: this.itemLines.map(line => ({item_code: line.item.sku_code, item_id: line.item.id, in_day_gr: parseInt(line.in_day_gr), in_day_gir: parseInt(line.in_day_gir) })),
                type: "Inbound Supplier SKU",
              })
              .then((resp) => {
                if (resp.code == 200) {
                  this.$vs.notify({
                    title: "Success",
                    text: "Data has been saved",
                    color: "success",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check",
                  });
                  this.handleClose()
                  this.$vs.loading.close();
                } else {
                  if (resp.data.duplicate_item_codes) {
                    const duplicateItems = resp.data.duplicate_item_codes.join(',')
                    this.$vs.notify({
                      color: "danger",
                      title: "Error",
                      text: `Duplicate items detected! ${duplicateItems}`,
                      position: "top-right",
                      iconPack: "feather",
                      icon: "icon-x-circle",
                    });
                  }
                  this.$vs.loading.close();
                }
              });
          }
        }
      });
    },
    handleSearch(searching) {
      
      const supplierIds = this.filter.supplier ? this.filter.supplier.map(item => item.id) : []
      const itemIds = this.filter.item ? this.filter.item.map(item => item.id) : []
      const dayGr = this.dayGr.length ? this.dayGr.map(item => Number(item.text)) : []
      const dayGir = this.dayGir.length ? this.dayGir.map(item => Number(item.text)) : []

      this.table.search = searching;
      this.table.page = 1;
      this.getData(supplierIds, itemIds, dayGr, dayGir)
    },
    handleChangePage(page) {
      
      const supplierIds = this.filter.supplier ? this.filter.supplier.map(item => item.id) : []
      const itemIds = this.filter.item ? this.filter.item.map(item => item.id) : []
      const dayGr = this.dayGr.length ? this.dayGr.map(item => Number(item.text)) : []
      const dayGir = this.dayGir.length ? this.dayGir.map(item => Number(item.text)) : []

      this.table.page = page;
      this.getData(supplierIds, itemIds, dayGr, dayGir)
    },
    handleSort(key, active) {
      
      const supplierIds = this.filter.supplier ? this.filter.supplier.map(item => item.id) : []
      const itemIds = this.filter.item ? this.filter.item.map(item => item.id) : []
      const dayGr = this.dayGr.length ? this.dayGr.map(item => Number(item.text)) : []
      const dayGir = this.dayGir.length ? this.dayGir.map(item => Number(item.text)) : []

      this.table.order = key;
      this.table.sort = active;
      this.getData(supplierIds, itemIds, dayGr, dayGir)
    },
    handleClose() {
      this.detailData = {
        in_day_gr: 1,
        in_day_gir: 1,
      }
      this.itemLines = [{
        item: null,
        in_day_gr: null,
        in_day_gir: null,
      }]
      this.detailS = false
      this.detail = false
      this.isEdit = false
      this.getData();
    },
    handleChangelength(val) {
      
      const supplierIds = this.filter.supplier ? this.filter.supplier.map(item => item.id) : []
      const itemIds = this.filter.item ? this.filter.item.map(item => item.id) : []
      const dayGr = this.dayGr.length ? this.dayGr.map(item => Number(item.text)) : []
      const dayGir = this.dayGir.length ? this.dayGir.map(item => Number(item.text)) : []

      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData(supplierIds, itemIds, dayGr, dayGir)
    },
    getData(supplierIds, itemIds, dayGr, dayGir) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/master/shelf-life", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            type: "Inbound Supplier SKU",
            supplier_id: supplierIds,
            item_id: itemIds,
            day_gr: dayGr,
            day_gir: dayGir,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;

            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getItems(val) {
      this.itemLines.map(line => line.item = null);
      if(this.itemLines.length > 1){
        this.itemLines.splice(1, this.itemLines.length-1);
      }
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/master/shelf-life/item", {
          params: {
            length: 0,
            query: this.table.search,
            order: "sku_code",
            sort: "asc",
            supplier_id2: val.id,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.items = resp.data.records.map(r => ({...r, text: `${r.sku_code} ${r.name}`}));
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleImport() {
      this.$router.push({
        name: "shelf-life-import-inbound-supplier-sku",
      });
    },
    handleDetail(id) {
      this.detail = true
      if (id) {
        this.isEdit = true
        this.itemLines = [{
          item: null,
          in_day_gr: null,
          in_day_gir: null,
        }]

        this.$vs.loading();
        this.$http
          .get(`/api/wms/v1/master/shelf-life/${id}`)
          .then((resp) => {
            if (resp.code == 200) {
              setTimeout(() => this.detailS = true, 1000)
              this.detailData = resp.data
              this.detailData.supplier = {
                id: this.detailData.supplier.id,
                name: this.detailData.supplier.name,
                text: `${this.detailData.supplier.code} ${this.detailData.supplier.name}`,
              }

              this.$http
              .get("/api/wms/v1/master/shelf-life/item", {
                params: {
                  length: 50,
                  query: this.table.search,
                  order: "sku_code",
                  sort: "asc",
                  supplier_id: this.detailData.supplier.id,
                },
              })
              .then((resp) => {
                if (resp.code == 200) {
                  if (resp.data.records) {
                    this.items = resp.data.records.map(r => ({...r, text: `${r.sku_code} ${r.name}`}));
                  }
                  this.$vs.loading.close();
                } else {
                  this.$vs.loading.close();
                }
              });

              if (this.detailData.item) {
                this.itemLines = [
                  {
                    item: {
                      id: this.detailData.item.id,
                      sku_code: this.detailData.item.sku_code,
                      name: this.detailData.item.name,
                      text: `${this.detailData.item.sku_code} ${this.detailData.item.name}`,
                    },
                    in_day_gr: this.detailData.in_day_gr,
                    in_day_gir: this.detailData.in_day_gir,
                  }
                ]
                this.detailData.in_day_gr = 1
                this.detailData.in_day_gir = 1
              }

              console.log(resp.data)
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
      } else {
        setTimeout(() => this.detailS = true, 1000)
      }
    },
    handleDelete(id) {
      this.deleteId = id;
      this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `Confirm`,
          text: "Please confirm to delete this data",
          accept: this.acceptDelete,
      });
    },
    acceptDelete() {
      this.$vs.loading();
      this.$http
          .delete("/api/wms/v1/master/shelf-life/" + this.deleteId)
          .then((resp) => {
              this.$vs.loading.close();
              if (resp.code == 200) {
                  this.$vs.notify({
                      color: "success",
                      title: "Success",
                      text: "The data was successfully deleted",
                      position: "top-right",
                      iconPack: "feather",
                      icon: "icon-x-circle",
                  });
              } else {
                  this.$vs.notify({
                      color: "danger",
                      title: "Error",
                      text: resp.message,
                      position: "top-right",
                      iconPack: "feather",
                      icon: "icon-x-circle",
                  });
              }
              this.getData();
          })
          .catch((error) => {
              this.$vs.loading.close();
              console.log(error);
          });
  },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 &&
        (charCode < 48 || charCode > 57))
      ) {
        evt.preventDefault();
      } else {
        if(Number(charCode) % 1 !== 0){
          evt.preventDefault();
        }else{
          return true;
        }
      }
    },
    onClickBtnFilter(){

      const supplierIds = this.filter.supplier ? this.filter.supplier.map(item => item.id) : []
      const itemIds = this.filter.item ? this.filter.item.map(item => item.id) : []
      const dayGr = this.dayGr.length ? this.dayGr.map(item => Number(item.text)) : []
      const dayGir = this.dayGir.length ? this.dayGir.map(item => Number(item.text)) : []

      this.getData(supplierIds, itemIds, dayGr, dayGir)
    },
    onClickBtnClear() {
      this.filter = { }
      this.dayGr = []
      this.dayGir = []      
      this.getData()
    },
  },
}
</script>

<style scoped>
.core {
  -webkit-transition: all 1s ease-out;
  -moz-transition: all 1s ease-out;
  -o-transition: all 1s ease-out;
  transition: all 1s ease-out;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 100px;
  padding: 5px;
}
.vue-tags-input {
  max-width: 100% !important;
}
</style>
